import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash'
import MemberServices from '../services/MemberService';

export const fetchRacebookIframeUrl = createAsyncThunk(
  'horseRacing/fetchRacebookIframeUrl',
  async (params, { rejectWithValue }) => {
    try {
      const response = await MemberServices.getRacebookIframeUrl(params);
      return response.data
    } catch(err) {
      console.log(err)
      return rejectWithValue(null)
    }
    
  }
)

export const RacebookSlice = createSlice({
    name: 'RacebookSlice',
    initialState:{
        loading: false,
        hasErrors: false,
        racebookIframeUrl: null,
    },
    reducers: {
      getHorseRacingIframeUrl: (state, {payload}) => {
        state.racebookIframeUrl = payload
      }
    },
    extraReducers: (builder) => {
      builder.addCase(fetchRacebookIframeUrl.fulfilled, (state, action) => {
        state.racebookIframeUrl = action.payload;
      })
      .addCase(fetchRacebookIframeUrl.pending, (state) => {
        if (state.loading === false) {
          state.loading = true
        }
      })
    },
  });
  
  export const {
    getHorseRacingIframeUrl,
  } = RacebookSlice.actions
  export const horseRacingSelector = state => state.HorseRacingSlice
  export default RacebookSlice.reducer;

 
  


// WEBPACK FOOTER //
// ./src/app/slices/RacebookSlice.js